
import React, { PureComponent } from 'react'
import { Field, reduxForm } from 'redux-form'
import { Col, Button, Alert } from 'react-bootstrap'
import InputPassword from '../../components/commons/form/InputPassword'
import InputPasswordStrengthIndicator from '../../components/commons/form/InputPasswordStrengthIndicator'
import AccessReset from '../../components/AccessReset'
import validatePassword from '../../components/access/validation/validatePassword'

class ResetPassword extends PureComponent {
  onSubmit (values) {
    return new Promise((resolve, reject) => {
      this.props.actions.resetPassword(values, this.props.t, resolve, reject, this.props.match.params.tokenId)
    })
  }

  componentDidMount () {
    if (this.props.match.params.tokenId) {
      this.props.actions.checkToken(this.props.match.params.tokenId)
    }
    this.props.actions.fetchPasswordPolicy()
  }

  render () {
    const { t, handleSubmit, error, invalid, submitting, emailAddress, passwordPolicy, formValues, formErrors } = this.props
    const tKey = 'RESET_PASSWORD.'
    let poweredBy
    var dataTheme = localStorage.getItem('theme')
    switch (dataTheme) {
      case 'dark':
        poweredBy = <img src="images/poweredbyD.png" ></img>
        break
      default:
        poweredBy = <img src="images/poweredby.png" ></img>
        break
    }
    return (
      <AccessReset>
        <div className='loginContainer'>
          <form id='ResetPassword' className="auth" onSubmit={handleSubmit(this.onSubmit.bind(this))}>
            <div className='elementContainer'>
              <div className='loginBox'>
                {poweredBy}
                <h1 className="logintext">{t('REMIND_PASSWORD.REMIND_PASSWORD')}</h1>
                <p className="user">{emailAddress}</p>
                <div className='fieldsContainer'>
                  <Field
                    t={t}
                    colSm={10}
                    colSmOffset={1}
                    id='newPassword'
                    name='newPassword'
                    placeholder={t(tKey + 'NEW_PASSWORD')}
                    controlLabel={t(tKey + 'NEW_PASSWORD')}
                    component={InputPassword}
                  />
                  <InputPasswordStrengthIndicator
                    t={t}
                    colSm={10}
                    colSmOffset={1}
                    passwordPolicy={passwordPolicy}
                    passwordValue={formValues && formValues.newPassword ? formValues.newPassword : ''}
                    passwordError={formErrors && formErrors.newPassword ? formErrors.newPassword : false}
                  />
                  <Field
                    t={t}
                    colSm={10}
                    colSmOffset={1}
                    id='pwdLoginRepeat'
                    name='pwdLoginRepeat'
                    placeholder={t(tKey + 'REPEAT_PASSWORD')}
                    controlLabel={t(tKey + 'REPEAT_PASSWORD')}
                    component={InputPassword}
                  />
                </div>
                <div className='flexInLine al-C'>
                  <Button
                    id='btn_change'
                    type='submit'
                    bsStyle='primary'
                    className='_Btn accept'
                    name='btn-reset-auth'
                    disabled={invalid || submitting}
                  >{t(tKey + 'CHANGE')}</Button>
                  {error &&
                  <Col smOffset={1} sm={10}>
                    <Alert bsStyle='danger' role='alert'>
                      <strong>{t('ERRORS.SERVER_ERROR')}</strong>
                      <p>{error}</p>
                    </Alert>
                  </Col>
                  }
                </div>
              </div>
            </div>
          </form>
        </div>
        <div className='transpContainer'></div>
      </AccessReset>
    )
  }
}

export default reduxForm({
  form: 'resetPassword',
  validate: validatePassword
})(ResetPassword)
